export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-green-50 via-white to-gray-50">
      {/* Background Design */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-96 h-96 bg-green-500/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-gray-900/10 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-gray-300 rounded-full"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] border border-gray-300 rounded-full"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center py-24 md:py-32">
        {/* Logo */}
        <div className="mb-6 md:mb-8">
          <img 
            src="https://static.readdy.ai/image/f60e38fb56feb0430ca9dd1939339c52/ccebb508c891aa10f301f784384056e8.png" 
            alt="The Owner Press" 
            className="h-14 md:h-20 mx-auto"
          />
        </div>

        {/* Tagline */}
        <h1 className="text-xl md:text-3xl font-bold text-gray-900 mb-8 md:mb-12">
          Decentralized Media Excellence
        </h1>

        {/* Description - Hidden on mobile */}
        <p className="hidden md:block text-lg md:text-xl text-gray-600 mb-12 max-w-3xl mx-auto leading-relaxed">
          Empowering independent journalists with professional infrastructure, global distribution networks, and ethical frameworks to compete with traditional media outlets.
        </p>

        {/* Mobile Description - Shorter */}
        <p className="md:hidden text-base text-gray-600 mb-8 max-w-xl mx-auto leading-relaxed px-4">
          Professional journalism infrastructure for independent reporters.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center px-4">
          <a href="#services" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-green-600 text-white text-sm md:text-base font-semibold rounded-full hover:bg-green-700 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
            <span>Explore Services</span>
            <i className="ri-arrow-right-line text-lg md:text-xl"></i>
          </a>
          <a href="#network" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 md:px-8 py-3 md:py-4 bg-gray-900 text-white text-sm md:text-base font-semibold rounded-full hover:bg-gray-800 transition-all hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
            <span>Join Network</span>
            <i className="ri-team-line text-lg md:text-xl"></i>
          </a>
        </div>

        {/* Stats - Mobile optimized */}
        <div className="grid grid-cols-3 gap-4 md:gap-8 mt-12 md:mt-20 max-w-3xl mx-auto px-4">
          <div className="text-center">
            <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">130+</div>
            <div className="text-xs md:text-sm font-medium text-gray-600">Distribution Outlets</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">50+</div>
            <div className="text-xs md:text-sm font-medium text-gray-600">CRM Integrations</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-4xl font-bold text-green-600 mb-1 md:mb-2">24/7</div>
            <div className="text-xs md:text-sm font-medium text-gray-600">News Coverage</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-gray-400"></i>
      </div>
    </section>
  );
}
